<template>
    <div class="innerMainContent">
        <div class="innerHeader">
            <div class="h1Wrap">
                <svg class="i_users"><use xlink:href="#i_users"></use></svg>
                <div class="innerH1Wrap">
                    <h1>{{ $t('guests') }}</h1>
                    <ul class="breadcrumb">
                        <li><router-link to="/">{{ $t('menu_hp') }}</router-link></li>
                        <li v-if="this.$store.state.user.type == 2"><router-link v-bind:to="'/event/wedding/'+eventID">{{ $t('event') }}</router-link></li>
                        <li class="active">{{ $t('guests') }}</li>
                    </ul>
                </div>
            </div>
            <div class="editEventActions">
                <button class="pullExcel" @click="showImportGuests" v-if="!presetLocked || $store.state.user.type === 2">
                    <svg><use xlink:href="#i_import"></use></svg>
                    <span>{{ $t('importGuests') }}</span>
                </button>
                <button class="addGuest" @click="showAddGuest" v-if="!presetLocked || $store.state.user.type === 2">
                    <svg><use xlink:href="#i_add_user"></use></svg>
                    <span>{{ $t('addGuest') }}</span>
                </button>
                <button v-if="$store.state.user.type == 2" class="pullExcel resetGuestList" @click="resetGuestList">
                    <svg><use xlink:href="#i_trash"></use></svg>
                    <span>{{ $t('resetGuestList') }}</span>
                </button>

            </div>
        </div>
        <div class="innerBox filterBox">
            <form style="min-height: 100px;" @submit.prevent="">
                <h3>
                    <svg><use xlink:href="#i_filter"></use></svg>
                    <span>{{ $t('filterGuests') }}</span>
                </h3>
                <div class="inputWrap">
                    <label for="f_groups">{{ $t('group') }}</label>
                    <div class="selectWrap">
                        <select name="f_groups" id="f_groups" v-model="groupFilter">
                            <option value="all">{{ $t('all') }}</option>
                            <option v-for="group in $store.state.guestGroups" v-bind:value="group">{{ group }}</option>
                        </select>
                        <svg class="i_select"><use xlink:href="#i_select"></use></svg>
                    </div>
                </div>
                <div class="inputWrap statusBarWrap">
                    <label>{{ $t('guestStatus') }}</label>
                    <div class="statusBar">
                        <button type="button" @click.prevent="setStatusFilter('coming')" id="arrive" class="statusBtn" v-bind:class="statusFilter == 'coming' ? 'active' : ''">
                            <svg class="i_arriving"><use xlink:href="#i_arriving"></use></svg>
                            <span style="display: block;line-height: 20px"><strong>{{ $t('willCome') }}<br/>{{guestsStats.coming}}</strong></span>
                        </button>
                        <button type="button" @click.prevent="setStatusFilter('notComing')" id="notArriving" class="statusBtn" v-bind:class="statusFilter == 'notComing' ? 'active' : ''">
                            <svg class="i_notArriving"><use xlink:href="#i_notArriving"></use></svg>
                            <span style="display: block;line-height: 20px"><strong>{{ $t('notComing') }}<br/>{{guestsStats.notComing}}</strong></span>
                        </button>
                        <button type="button" @click.prevent="setStatusFilter('maybeComing')" id="maybeArriving" class="statusBtn" v-bind:class="statusFilter == 'maybeComing' ? 'active' : ''">
                            <svg class="i_maybeArriving"><use xlink:href="#i_maybeArriving"></use></svg>
                            <span style="display: block;line-height: 20px"><strong>{{ $t('mayCome') }}<br/>{{guestsStats.maybe}}</strong></span>
                        </button>
                        <button type="button" @click.prevent="setStatusFilter('notResponded')" id="didentAnswer" class="statusBtn" v-bind:class="statusFilter == 'notResponded' ? 'active' : ''">
                            <svg class="i_didentAnswer"><use xlink:href="#i_didentAnswer"></use></svg>
                            <span style="display: block;line-height: 20px"><strong>{{ $t('notResponded') }}<br/>{{guestsStats.notResponded}}</strong></span>
                        </button>
                        <button type="button" @click.prevent="setStatusFilter('reserve')" id="reserve" class="statusBtn" v-bind:class="statusFilter == 'reserve' ? 'active' : ''">
                            R
                            <span style="display: block;line-height: 20px"><strong>{{ $t('reserve') }}<br/>{{guestsStats.reserve}}</strong></span>
                        </button>
                        <button type="button" @click.prevent="setStatusFilter('all')" id="all" class="statusBtn" v-bind:class="statusFilter == 'all' ? 'active' : ''">
                            <span>{{ $t('all') }}<strong><br/>{{guestsStats.coming+guestsStats.notComing+guestsStats.maybe+guestsStats.notResponded+guestsStats.reserve}}</strong></span>
                        </button>
                    </div>
                </div>
                <div class="orDivider">{{ $t('or') }}</div>
                <div class="inputWrap searchWrapper" style="margin-top: 30px">
                    <input type="search" v-bind:placeholder="$t('searchGuest')" v-model="openSearch">
                    <button class="searchEvent">
                        <svg><use xlink:href="#i_search"></use></svg>
                        <span class="sr-only">{{ $t('searchGuest') }}</span>
                    </button>
                </div>
            </form>

        </div>
        <div class="pagination">
            <div class="side1">
                <label for="showAmount">{{ $t('show') }}</label>
                <div class="selectWrap">
                    <select name="showAmount" id="showAmount" v-model="stackSize" @change="currentPage=1">
                        <option v-for="n in 500" v-bind:value="n" v-if="(!(n%50))">{{ n }}</option>
                    </select>
                    <svg class="i_select"><use xlink:href="#i_select"></use></svg>
                </div>
                <span class="goustsTxt">{{ $t('guests') }}</span>
                <span class="goustsRows">{{ getStack('min') }}-{{ getStack('max') }}</span>
                <span class="outOfTxt">{{ $t('outOf') }}</span>
                <span class="goustsTotalRows">{{ getGuests().length }}</span>
            </div>
            <div class="side2">
                <button class="prev disabled">
                    <svg class=""><use xlink:href="#i_select"></use></svg>
                    <span class="sr-only">{{ $t('previous') }}</span>
                </button>
                <ul>
                    <li v-for="page in getPages()" v-bind:class="(currentPage == page ? 'active' : '')" @click="setPage(page)">
                        <button>{{ page }}</button>
                        <span class="sr-only">{{ $t('pageNum',{page:page}) }}</span>
                    </li>
                </ul>
                <button class="next">
                    <svg class=""><use xlink:href="#i_select"></use></svg>
                    <span class="sr-only">{{ $t('next') }}</span>
                </button>
            </div>
        </div>
        <div class="innerBox">
            <div class="guestsTable">
                <table>
                    <tr>
                        <th>#</th>
                        <th>{{ $t('fullName') }}</th>
                        <th v-if="isConference">{{ $t('company') }}</th>
                        <th v-if="isConference">{{ $t('role') }}</th>
                        <th>{{ $t('quantity') }}</th>
                        <th>{{ $t('guestStatus') }}</th>
                        <th>{{ $t('group') }}</th>
                        <th v-if="!$store.state.isTablet">{{ $t('contactInfo') }}</th>
                        <th>{{ $t('tableNum') }}</th>
                        <th v-if="!$store.state.isTablet">{{ $t('moreDetails') }}</th>
                        <th v-if="!$store.state.isTablet">{{ $t('notes') }}</th>
                        <th v-if="!$store.state.isTablet">{{ $t('printNote') }}</th>
                        <th v-if="!$store.state.isTablet">{{ $t('tracking') }}</th>
                        <th></th>
                    </tr>
                    <tr v-if="showLoader">
                        <td colspan="9" style="padding: 70px" class="text-center"><rotate-loader style="opacity: .6" :color="'#132C43'"></rotate-loader></td>
                    </tr>
                    <tr v-if="getGuestsTable().length == 0 && !showLoader">
                        <td colspan="9" style="padding: 30px;" class="text-center"><strong>{{ $t('notGuestsFound') }}</strong></td>
                    </tr>
                    <GuestRow v-if="!showLoader" v-for="(guest,guestKey) of getGuestsTable()" :key="guestKey" :presetLocked="presetLocked === 1" :guest="guest" v-on:deleted="deleteGuest" :isConference="isConference"></GuestRow>
                </table>
            </div>
        </div>
        <div class="pagination">
            <div class="side1">
                <label for="showAmount2">{{ $t('show') }}</label>
                <div class="selectWrap">
                    <select name="showAmount2" id="showAmount2" v-model="stackSize" @change="currentPage=1">
                        <option v-for="n in 500" v-bind:value="n" v-if="(!(n%50))">{{ n }}</option>
                    </select>
                    <svg class="i_select"><use xlink:href="#i_select"></use></svg>
                </div>
                <span class="goustsTxt">{{ $t('guests') }}</span>
                <span class="goustsRows">{{ getStack('min') }}-{{ getStack('max') }}</span>
                <span class="outOfTxt">{{ $t('outOf') }}</span>
                <span class="goustsTotalRows">{{ getGuests().length }}</span>
            </div>
            <div class="side2">
                <button class="prev disabled">
                    <svg class=""><use xlink:href="#i_select"></use></svg>
                    <span class="sr-only">{{ $t('previous') }}</span>
                </button>
                <ul>
                    <li v-for="page in getPages()" v-bind:class="(currentPage == page ? 'active' : '')" @click="setPage(page)">
                        <button>{{ page }}</button>
                        <span class="sr-only">{{ $t('pageNum',{page:page}) }}</span>
                    </li>
                </ul>
                <button class="next">
                    <svg class=""><use xlink:href="#i_select"></use></svg>
                    <span class="sr-only">{{ $t('next') }}</span>
                </button>
            </div>
        </div>

        <AddGuestModal :event="eventID" v-on:addGuest="addGuest"></AddGuestModal>
        <GuestsImportModal v-on:imported="importGuests" :addGuestEvent="eventID"></GuestsImportModal>

    </div>
</template>

<script>
    import RotateLoader from 'vue-spinner/src/RotateLoader.vue'
    import GuestRow from './GuestRow'
    import AddGuestModal from './AddGuestModal'
    import GuestsImportModal from './GuestsImportModal'
    export default {
        name: "Guests",
        components: {
            GuestRow,
            AddGuestModal,
            GuestsImportModal,
            RotateLoader
        },
        watch:{
          guests:function(){
              this.calculateGuests();
          }
        },
        data(){
            return{
                guests:[],
                guestsStats:{
                    notResponded:0,
                    coming:0,
                    maybe:0,
                    reserve:0,
                    notComing:0
                },
                stackSize:50,
                eventID:0,
                currentPage:1,
                openSearch:'',
                groupFilter:'all',
                statusFilter:'all',
                showLoader:false,
                isConference:false,
                presetLocked:false
            }
        },
        beforeMount(){
            this.showLoader = true;
            let eventID = this.$router.currentRoute.params.eventID;
            if(typeof eventID ==='undefined' || !eventID) this.$router.push('/');
            this.$store.dispatch('getEvent',eventID)
                                    .then(response =>{
                                        //success
                                        this.eventID = eventID;
                                        this.isConference = response.data.isConference;
                                        this.fetchGuests();
                                        this.presetLocked = response.data.presetLocked;
                                    })
                                    .catch(err => {
                                        //err
                                        console.warn(err)
                                        this.$router.push('/');
                                    })
        },
        mounted(){
            $(document).ready(function() {
                $("body").on('click', '.pagination .side2 ul li button', function (e) {
                    $('.pagination .side2 ul li.active').removeClass('active');
                    $(this).parent().addClass('active');
                });
                $("body").on('click', '.textInputPop', function (e) {
                    $(this).siblings('.editibleEl').focus();
                });

                /******************************************/
                let hide1 = true;
                $('body').on("click", function () {
                    if (hide1) $('.g_status').parent().removeClass('active');
                    hide1 = true;
                });
                $('body').on('click', '.g_status', function () {
                    let self = $(this).parent();
                    self.addClass('active');
                    hide1 = false;
                });
                $('body').on('click', '.g_status_drop', function () {
                    hide1 = false;
                });

                /******************************************/
                let hide2 = true;
                $('body').on("click", function () {
                    if (hide2) $('.g_call').siblings('ul').removeClass('active');
                    hide2 = true;
                });
                $('body').on('click', '.g_call', function () {
                    let self = $(this).siblings('ul');
                    self.addClass('active');
                    hide2 = false;
                });
                $('body').on('click', '.g_callWrap ul button', function () {
                    hide2 = false;
                });


            });

        },
        methods:{
            calculateGuests(){
                this.guestsStats = {
                    notResponded:0,
                    coming:0,
                    maybe:0,
                    reserve:0,
                    notComing:0
                };
                if(this.guests.length > 0 ){
                    let _this = this;
                    this.guests.forEach((_)=>{
                        _this.guestsStats.notResponded += !isNaN(parseInt(_.status.notResponded)) ? parseInt(_.status.notResponded) : 0;
                        _this.guestsStats.coming += !isNaN(parseInt(_.status.coming)) ? parseInt(_.status.coming) : 0;
                        _this.guestsStats.maybe += !isNaN(parseInt(_.status.maybeComing)) ? parseInt(_.status.maybeComing) : 0;
                        _this.guestsStats.notComing += !isNaN(parseInt(_.status.notComing)) ? parseInt(_.status.notComing) : 0;
                        _this.guestsStats.reserve += !isNaN(parseInt(_.status.reserve)) ? parseInt(_.status.reserve) : 0;
                    })
                }
            },
            getGuests(){
                let _this = this;
                return this.guests.filter((guest)=>{
                    if(_this.statusFilter != 'all' && guest.status[_this.statusFilter] <= 0) return false;
                    if(_this.groupFilter != 'all' && guest._group != _this.groupFilter) return false;
                    if(_this.openSearch != '' && guest.tableID != _this.openSearch && !guest.fullName.toString().toLowerCase().includes(_this.openSearch.toString().toLowerCase()) && !guest.phone.toString().includes(_this.openSearch.toString().toLowerCase())) return false;
                    return true;
                });
            },
            getGuestsTable(){
                let start = ((this.stackSize*this.currentPage)-this.stackSize);
                let end = (this.stackSize*this.currentPage);
                let _guests = this.getGuests().slice(start,end)
                return _guests;
            },
            setStatusFilter(_){
                this.statusFilter = _;
            },
            getStack(_ = 'min'){
                switch(_){
                    case 'min':
                        return (this.getGuests()[0] ? this.getGuests()[0].key : 0);
                        break;
                    case 'max':
                        return (this.getGuests()[0] ? (this.getGuests()[ this.getGuests().length-1 ].key+1) : this.guests.length+1);
                        break;
                }
            },
            fetchGuests(forceUpdate = false){
                this.$store.dispatch('getGuests',this.eventID)
                    .then(response =>{
                        //success
                        this.guests = response.data
                        for(let g in this.guests){
                            this.guests[g].key = parseInt(g);
                        }
                        if(forceUpdate) this.$forceUpdate();
                        this.showLoader = false;
                    })
                    .catch(err => {
                        //err
                        console.warn(err)
                        this.$router.push('/');
                        this.showLoader = false;
                    })
            },
            getPages(){
                let pages = Math.ceil(this.guests.length/this.stackSize);
                return (pages <= 0 ? 1 : pages)
            },
            setPage(_){
                this.currentPage = _;
            },
            deleteGuest(id){
                this.guests.forEach((guest,index)=>{
                    if(guest.id == id) delete this.guests[index]
                });
                this.$forceUpdate();
            },
            showAddGuest(){
                let _this = this;
                $('[data-id="eventID"]').val(this.eventID);

                setTimeout(function(){
                    $('[data-id="eventID"]').val(_this.event.id);
                },1000);
                $('.addGuestForm #gQuantity').val('1');
                $('.addGuestForm .value.vQyt').text("1");
                $("#modal-addGuest").iziModal({
                    autoOpen: 1,
                });
            },
            showImportGuests(){
                $('[data-id="eventID"]').val(this.eventID)
                $("#modal-importGuests").iziModal({
                    autoOpen: 1,
                });
            },
            addGuest(_){
                this.guests.push(_);

                if(_._group && _._group != '' && !this.$store.state.guestGroups.includes(_._group)) this.$store.state.guestGroups.push(_._group);

                this.fetchGuests()
                this.$forceUpdate()
            },
            importGuests(data){
                $('input[type="file"]').val('').change();
                $("#modal-importGuests").iziModal('close')
                this.fetchGuests()
                this.$forceUpdate()

                let _this = this;
                setTimeout(function(){
                    if(typeof data.collisions !=='undefined' && data.collisions.length){
                        _this.$swal({
                            confirmButtonText: _this.$t('phoneDuplicatesTitle'),
                            type: 'warning',
                            html: `${_this.$t('phoneDuplicatesText')}<br/>${data.collisions.join(', ')}`,
                            timer:999999
                        })
                    }
                },1000);

            },
            resetGuestList(){
                this.$swal({
                    title: this.$t('resetGuestListPrompt'),
                    text: this.$t('unrevetableOperation'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText: this.$t('no')
                }).then((result) => {

                    if (result === true) {
                        this.guestsReset()
                    }
                })
                    .catch(this.$swal.noop);
            },
            guestsReset(){
                let _this = this;
                this.$swal({
                    title: this.$t('beforeWeReset'),
                    text: this.$t('enterYourPassword'),
                    input: 'password',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    showLoaderOnConfirm:true,
                    confirmButtonText: this.$t('resetGuests'),
                    cancelButtonText: this.$t('cancel'),
                    preConfirm: function(value) {
                        return new Promise(function(resolve) {
                            if (typeof value ==='undefined' || value == '') {
                                _this.$swal.showValidationError(
                                    _this.$t('presetNameRequired')
                                )
                                _this.$swal.hideLoading();
                            }else {

                                //validate
                                _this.$store.dispatch('checkPassword',value)
                                                        .then(response =>{
                                                            //success
                                                            resolve()
                                                        })
                                                        .catch(err => {
                                                            //err
                                                            _this.$swal({
                                                                confirmButtonText: _this.$t('okButton'),
                                                                type: 'error',
                                                                title: _this.$t('passwordIncorrect'),
                                                                timer: 3000
                                                            })
                                                        })

                            }
                        });
                    },
                }).then((password) => {

                    this.$store.dispatch('resetGuests',this.eventID)
                                            .then(response =>{
                                                //success
                                                this.guests = [];
                                                this.$forceUpdate();
                                            })
                                            .catch(err => {
                                                //err
                                                this.$swal({
                                                    confirmButtonText: this.$t('okButton'),
                                                    type: 'error',
                                                    title: this.$t('fatalError'),
                                                    timer: 3000
                                                })
                                            })

                }).catch(this.$swal.noop);
            }
        },
    }
</script>
<style scoped>

    h2{
        color:#7893c1;
        font-size: 1.706rem;
        font-weight: 700;
    }
    h3{
        color: #293b5a;
        font-weight: 700;
        font-size:1.059rem;
    }
    .innerMainContent{
        padding:55px 45px;
        float: right;
        width:100%;
    }

    .h1Wrap .i_users{
        width:36px;
        height:28px;
    }
    .innerBox{
        padding:23px;
    }
    .innerBox.filterBox{
        padding:23px;
    }

    .innerBox.filterBox h3{
        display: inline-block;
        vertical-align: middle;
    }
    .innerBox.filterBox h3 span{
        color:#293b5a;
        font-size: 1rem;
        display: block;
        font-weight: 700;
        margin-top:10px;
    }
    .innerBox.filterBox h3 svg{
        width:24px;
        height:24px;
        display: block;
        margin:0 auto;
        fill:#293b5a;
    }
    .innerBox.filterBox .inputWrap{
        display: inline-block;
        vertical-align: middle;
        margin-right:15px;
        width:250px;
    }
    .innerBox.filterBox .inputWrap.statusBarWrap{
        width:530px;
    }
    .innerBox.filterBox  .inputWrap + .inputWrap{
        margin-top:0;

    }
    .innerBox.filterBox .inputWrap label{
        color:#293b5a;
        font-size: 0.8824rem;
        font-weight: bold;
    }
    .innerBox.filterBox .inputWrap input,
    .innerBox.filterBox .inputWrap select{
        background:#fff;
        color:#434343;
        height:43px;
        line-height: 40px;
    }
    .innerBox.filterBox .inputWrap select#eventStatus{
        background: #f6f6f6
    }
    .innerBox.filterBox .inputWrap.searchWrapper{
        width:335px;
    }
    .innerBox.filterBox .inputWrap.searchWrapper input{
        padding-left: 40px;
    }
    .innerBox.filterBox .inputWrap.searchWrapper .searchEvent{
        position: absolute;
        top: calc(50% - 10px);
        left: 20px;
    }
    .innerBox.filterBox .inputWrap.searchWrapper .searchEvent svg{
        fill: #293b5a;
        width: 18px;
        height: 20px;
        display: block;
    }
    .orDivider{
        display: inline-block;
        height: 43px;
        width: 43px;
        line-height: 43px;
        text-align: center;
        border-radius: 50%;
        background: #e0e0e0;
        color: #414141;
        font-size: 1rem;
        font-style: italic;
        margin: 0px 15px;
        vertical-align: bottom;
    }

    .editEventActions{
        float:left;
        margin-top: 6px;
    }
    .editEventActions button{
        width: 181px;
        height: 42px;

        border-radius: 21px;
    }
    .addGuest{
        border: 1px solid #52dbcd;
        background: -moz-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* ff3.6+ */
        background: -webkit-gradient(linear, left top, right top, color-stop(0%, rgba(41, 59, 90, 1)), color-stop(100%, rgba(123, 150, 196, 1)));
        /* safari4+,chrome */
        background: -webkit-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* safari5.1+,chrome10+ */
        background: -o-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* opera 11.10+ */
        background: -ms-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* ie10+ */
        background: linear-gradient(90deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* w3c */
        filter: progid: DXImageTransform.Microsoft.gradient( startColorstr='#293b5a', endColorstr='#7b96c4', GradientType=1 );
        /* ie6-9 */
    }
    .addGuest svg{
        display: inline-block;
        vertical-align: middle;
        width: 24px;
        height: 24px;
        fill: #fff;
        margin-left: 5px;
    }
    .addGuest span{
        display: inline-block;
        vertical-align: middle;
        margin-top: -2px;
        font-size: 0.8235rem;
        font-weight: 700;
        color:#fff;
    }
    .pullExcel{
        width: 215px!important;
        border: 1px solid #44536e;
        margin-left: 10px;
    }
    .pullExcel svg{
        display: inline-block;
        vertical-align: middle;
        width: 24px;
        height: 24px;
        margin-left: 5px;
        fill:#7b96c4;
    }
    .pullExcel span{
        display: inline-block;
        vertical-align: middle;
        margin-top: -2px;
        font-size: 0.8235rem;
        font-weight: 700;
        color:#44536e;
    }
    .statusBar{
        width: 530px;
        height: 43px;
        line-height: 40px;
        border-radius: 27px;
        border: 1px solid #bfc1c5;
        display: inline-block;
        vertical-align: middle;
    }
    .statusBtn{
        float: right;
        width:16.66962%;
        text-align: center;
        padding: 0 5px;
    }
    #all span{
        color:#293b5a;
        font-weight: 700;
    }
    #all{
        border-radius: 27px 0 0 27px;
    }
    .statusBar .active{
        background: #f3f3f3 !important;
    }
    .statusBtn svg{
        width:24px;
        height:24px;
        display: inline-block;
        vertical-align: middle;
        margin-left:5px;
    }
    .statusBtn span{
        color:#555555;
        font-size: 0.7rem;
        display: inline-block;
        vertical-align: middle;
    }
    svg.i_arriving{
        fill:#41b53e;
    }
    svg.i_notArriving{
        fill:#bb1b1b;
    }
    svg.i_maybeArriving{
        fill:#e49e9e;
    }
    svg.i_didentAnswer{
        fill:#656565;
    }
    .guestsTable{
        width:100%;
        float: right;
        margin-top:25px;
        position:relative;
    }
    .guestsTable table{
        width:100%;
        border-spacing: 1px;
    }
    .guestsTable table tr:first-child{
        border-bottom:1px solid #293b5a;

    }
    .guestsTable table tr th{
        padding:15px;
        color:#7b96c4;
        font-weight:700;
        font-size: 1.059rem;
    }
    .guestsTable table tr td{
        padding:13px;
        color:#5a5a5a;
        font-size:1rem;
        position: relative;

    }
    .guestsTable table tr td label + label:before{
        content:"|";
        padding:0 5px;
    }
    .guestsTable table tr td label.longTxt{
        width:100%;
        min-width: 150px;
    }
    .guestCounter{
        width: 110px;
        max-width: 100%;
        height: 44px;
        line-height: 40px;
        border-radius: 27px;
        border: 1px solid #bfc1c5;
        float: right;
    }
    .guestCounter span,
    .guestCounter input{
        width:33.3%;
        float: right;
        text-align: center;
        height: 100%;
    }
    .guestCounter span.plus{
        background: #f2f2f2;
        border-radius: 0 27px 27px 0;
    }
    .guestCounter span.minus{
        background: #f2f2f2;
        border-radius: 27px 0 0 27px;
    }
    .guestCounter span svg{
        width: 17px;
        height: 100%;
        fill: #293b5a;
        display: block;
        margin:0 auto;
    }
    .guestCounter input.value{
        font-size: 1rem;
        color: #434343;
        background: #fff;
    }
    .editibleEl{
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 8px;
        opacity: 0;
        z-index: -1;
        border: 1px solid #bfc1c5;
        border-radius: 27px;
        display: block;
        background: #fff;
        width: 90%;
        height: 44px;
        padding-right: 7px;
        transition: opacity .25s ease-in-out;
        -moz-transition: opacity .25s ease-in-out;
        -webkit-transition: opacity .25s ease-in-out;
    }
    .counterPop{
        min-width: 85px;
    }
    .innerMainContent .guestCounter:not(.innerCounter).active,
    .editibleEl:focus {
        z-index: 1;
        opacity: 1;
        transition: opacity .25s ease-in-out;
        -moz-transition: opacity .25s ease-in-out;
        -webkit-transition: opacity .25s ease-in-out;
    }
    .innerMainContent .guestCounter:not(.innerCounter){
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 8px;
        opacity: 0;
        z-index: -1;
        border: 1px solid #bfc1c5;
        border-radius: 27px;
        display: block;
        background: #fff;
        width: 90%;
        height: 44px;
        transition: opacity .25s ease-in-out;
        -moz-transition: opacity .25s ease-in-out;
        -webkit-transition: opacity .25s ease-in-out;
    }
    .guestsTable table tr{
        background: #fff;
        /*border:1px solid transparent;*/

    }
    .guestsTable table tr:nth-child(2n+2){
        background: #f0f0f0;
    }
    .deleteGuest svg{
        width:18px;
        height:19px;
        fill:#293b5a;
    }
    .pagination{
        width:100%;
        float: right;
    }
    .pagination .side1{
        float: right;
    }
    .pagination .side1 label{
        display: inline-block;
        vertical-align: middle;
        margin-bottom: 0px;
        margin-left:10px;
        font-weight: 700;
        color:#293b5a;
        font-size: 0.8235rem;
    }
    .pagination .side1 select{
        width: 74px;
        height: 34px;
        background: #fff;
        border-radius: 27px;
        color: #666666;
        font-size: 0.8235rem;
        padding: 0 10px 0 20px;
        border-color: #7993c0;
    }
    .pagination .side1 .selectWrap{
        display: inline-block;
        margin-left: 10px;
    }
    .pagination .side1 .goustsTotalRows,
    .pagination .side1 .goustsTxt{
        color:#000000;
        font-weight: 700;
        font-size: 0.8235rem;
    }
    .pagination .side1 .goustsRows,
    .pagination .side1 .outOfTxt{
        color:#000000;
        font-weight: 400;
        font-size: 0.8235rem;
    }

    .pagination .side1 .selectWrap .i_select{
        width: 11px;
        height: 6px;
        top: calc(50% - 2px);
        fill: #293b5a;
        left: 13px;
    }
    .pagination .side2{
        float: left;
    }
    .pagination .side2 .prev svg,
    .pagination .side2 .next svg{
        width:11px;
        height:6px;
        fill:#293b5a;
    }
    .pagination .side2 .prev.disabled svg,
    .pagination .side2 .next.disabled svg{
        fill:#adadad;
    }
    .pagination .side2 .prev{
        transform: rotate(-90deg);
        display: inline-block;
        vertical-align:middle;
    }
    .pagination .side2 .next{
        transform: rotate(90deg);
        display: inline-block;
        vertical-align:middle;
    }
    .pagination .side2 ul li,
    .pagination .side2 ul{
        display: inline-block;
        vertical-align: middle;
    }
    .pagination .side2 ul li button{
        width:31px;
        height:31px;
        line-height: 30px;
        border: 1px solid transparent;
        border-radius: 50%;
        text-align: center;
        color:#000000;
        font-size: 0.8235rem;
    }
    .pagination .side2 ul li.active button{
        background: #fff;
        border-color:#7791be;
        color:#7791be;
    }
    .g_status svg{
        width:21px;
        height:21px;
    }
    .g_status>span{
        display: inline-block;
        vertical-align: middle;
        text-align: center;
        color:#8e8e8e;
        font-size: 0.6471rem;
        margin:0 2px;
    }
    .g_status_drop{
        position: absolute;
        top: calc(100% - 10px);
        background: #fff;
        border: 1px solid #bfc1c5;
        display: none;
        z-index: 1;
    }
    .active .g_status_drop{
        display: block;
    }
    .g_status_drop svg{
        width:25px;
        height:25px;
        display: inline-block;
        vertical-align: middle;

    }
    .g_status_drop span{
        display: inline-block;
        vertical-align: middle;
        color:#1c1c1c;
        font-size: 0.9412rem;
    }
    .g_status_drop .yes,
    .g_status_drop .no,
    .g_status_drop .maybe,
    .g_status_drop .noAnswer{
        float: right;
    }
    .yes svg{fill:#44b642;}
    .no svg{fill:#ba1818;}
    .maybe svg{fill:#e5a2a2;}
    .noAnswer svg{fill:#797979;}
    .guestCounter.innerCounter{
        float: left;
        width: 71px;
        height: 30px;
        line-height: 28px;
    }
    .guestCounter.innerCounter span svg{
        width:9px;
    }
    .g_status_drop ul{
        width:180px;
    }
    .g_status_drop ul li{
        float: right;
        width:100%;
        padding: 5px;
    }
    .g_status_drop ul li:nth-child(even){
        background: #f0f0f0;
    }
    .guestCounter.innerCounter span.plus,
    .guestCounter.innerCounter span.minus{
        background: #fff;
    }
    .guestCounter.innerCounter span.value{
        background: #fff;
        border-right:1px solid #bfc1c5;
        border-left:1px solid #bfc1c5;
    }
    .g_status{

        border-radius: 27px;
    }
    .active .g_status{
        padding: 5px 10px;
        background: #fff;
        border: 1px solid #bfc1c5;

    }
    .textInputPop + .selectWrap svg{
        display: none;
    }
    .textInputPop + .selectWrap select:focus + svg{
        display: block;
    }
    .textInputPop + .selectWrap{
        position: static;
    }
    .textInputPop + .selectWrap .i_select{
        z-index: 9;
        width: 11px;
        height: 6px;
        top: calc(50% - 2px);
        left: 30px;
    }
    .g_info svg{fill:#000;height:18px;}
    .gender svg{width:14px;}
    .crown svg{width:21px;}
    .access svg{width:15px;}
    .veg svg{width:17px;}
    .kosher svg{width:16px;}
    .g_info_drop ul{}
    .g_info_drop ul li{
        display: inline-block;
        vertical-align: middle;
        width: 20%;
        background: #fff!important;
    }

    .g_callWrap svg{
        width:22px;
        height:22px;
        display: block;
        margin:0 auto;
    }
    .g_callWrap .noCall svg{fill:#ff0000;}
    .g_callWrap .yesCall svg{fill:#2edf71;}
    .g_callWrap ul{
        position: absolute;
        top: 50%;
        right:50%;
        transform: translate(50%,-50%);
        border: 1px solid #bfc1c5;
        border-radius: 27px;
        background: #fff;
        display: none;
    }
    .g_callWrap ul.active{
        display: block;
    }
    .g_callWrap{
        text-align: center;

    }
    .g_callWrap ul li{
        padding:10px;
    }
    .g_callWrap ul li button{
        display: block;
    }
    .g_callWrap ul li + li{
        border-top: 1px solid #bfc1c5;
        background: #f0f0f0;
        border-radius: 0 0 27px 27px;
    }


    #modal-addGuest{
        max-width: 700px!important;
        background: #efefef;
    }
    #modal-addGuest .row + .row{
        margin-top:20px;
    }
    #modal-addGuest .inputWrap input, #modal-addGuest .inputWrap select, #modal-addGuest{
        background: #fff;
        color:#555555;
        font-size: 0.8235rem;
    }
    #modal-addGuest h2{
        color:#293b5a;
        font-size: 2rem;
        font-weight: 700;
        margin-bottom: 20px;
    }

    #modal-addGuest label{
        color:#434343;
        font-size: 1rem;
        margin-bottom: 10px;
        display: block;
    }

    #modal-addGuest .statusDropDown li{
        padding:7px 0;
        cursor: pointer;
    }
    #modal-addGuest .selectedValue span svg,
    #modal-addGuest .statusDropDown li svg{
        width:24px;
        height:24px;
        vertical-align: middle;
        display: inline-block;
        margin-left:7px;
    }
    #modal-addGuest .selectedValue span span,
    #modal-addGuest .statusDropDown li span{
        vertical-align: middle;
        display: inline-block;
        color:#555555;
        font-size: 0.8235rem;
    }
    #modal-addGuest .selectedValue{
        width: 100%;
        height: 54px;
        line-height: 54px;
        border-radius: 27px;
        border: 1px solid #bfc1c5;
        background: #fff;
        padding: 0 15px;
        color: #fff;
    }
    #modal-addGuest .statusDropDown{
        z-index: 1;
        background: #fff;
        width: 125px;
        padding: 0 10px;
        border: 1px solid #dddddd;
        position: absolute;
        top: calc(100% + 15px);
        right: 50%;
        transform: translateX(50%);
        display: none;
    }
    #modal-addGuest .statusDropDown.open{
        display: block;
    }
    #modal-addGuest .statusDropDown:before {
        content: "";
        width: 0;
        height: 0;
        border-left: 12px solid transparent;
        border-right: 12px solid transparent;
        border-bottom: 12px solid #dddddd;
        position: absolute;
        bottom: 100%;
        right: calc(50% - 6px);
    }
    #modal-addGuest .statusDropDown:after {
        content: "";
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid #fff;
        position: absolute;
        bottom: 100%;
        right: calc(50% - 4px);
    }
    #modal-addGuest .secondLevel{
        margin:0 -7px;
    }
    #modal-addGuest .secondLevel div[class^="col-"]{
        padding:0 7px;
    }
    #modal-addGuest .selectedValue{
        position: relative;
    }
    #modal-addGuest .selectedValue .i_select{
        width:16px;
        height:9px;
        position:absolute;
        top:calc(50% - 4px);
        left:10px;
        fill:#8798b5;
    }
    #modal-addGuest .guestCounter{
        width: 100%;
        height: 54px;
        line-height: 52px;
        border-radius: 27px;
        border: 1px solid #bfc1c5;
        float: right;
    }
    #modal-addGuest .guestCounter span{
        width:33.3%;
        float: right;
        text-align: center;
        height: 100%;
    }
    #modal-addGuest .guestCounter span.plus{
        background: #f2f2f2;
        border-radius: 0 27px 27px 0;
    }
    #modal-addGuest .guestCounter span.minus{
        background: #f2f2f2;
        border-radius: 27px 0 0 27px;
    }
    #modal-addGuest .guestCounter span svg{
        width: 17px;
        height: 100%;
        fill: #293b5a;
        display: block;
        margin:0 auto;
    }
    #modal-addGuest .guestCounter span.value{
        font-size: 1rem;
        color: #434343;
    }
    .resetGuestList{
        border-color:#c30303
    }
    .resetGuestList svg{
        fill:#c30303
    }
    .resetGuestList span{
        color:#c30303
    }

    @media only screen and (max-width:1450px){

    }

    @media only screen and (max-width:769px) and (max-height: 1025px) {
        .innerBox,.innerBox.filterBox{
            padding: 20px 0px 20px 0px;
        }
        .statusBar .active{
            height:100%
        }
        .innerBox.filterBox .inputWrap.statusBarWrap{
            width: 600px;
            padding-bottom: 20px;
        }
    }
</style>
